import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sm:mx-auto sm:w-full sm:max-w-md" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-6 text-center text-4xl font-extrabold font-ammocorps text-gray-900" }, " BACKOFFICE ADMIN ")
], -1)
const _hoisted_3 = { class: "mt-8 sm:mx-auto sm:w-full sm:max-w-md" }
const _hoisted_4 = { class: "bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm text-left font-medium text-gray-700"
}, " Email address ", -1)
const _hoisted_6 = { class: "mt-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block text-sm text-left font-medium text-gray-700"
}, " Password ", -1)
const _hoisted_8 = { class: "mt-1" }
const _hoisted_9 = {
  type: "submit",
  class: "group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
}
const _hoisted_10 = { class: "absolute left-0 inset-y-0 flex items-center pl-3" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Sign in ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LockClosedIcon = _resolveComponent("LockClosedIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          class: "space-y-6",
          onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
        }, [
          _createElementVNode("div", null, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                id: "email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                name: "email",
                type: "email",
                autocomplete: "email",
                required: "",
                class: "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              }, null, 512), [
                [_vModelText, _ctx.email]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                id: "password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                name: "password",
                type: "password",
                autocomplete: "current-password",
                required: "",
                class: "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              }, null, 512), [
                [_vModelText, _ctx.password]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("button", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_LockClosedIcon, {
                  class: "h-5 w-5 text-indigo-500 group-hover:text-indigo-400",
                  "aria-hidden": "true"
                })
              ]),
              _hoisted_11
            ])
          ])
        ], 32)
      ])
    ])
  ]))
}